/* kd-slider-dots.js — points de navigation pour le carrousel bannières catégories (mobile).
   Construit un dot par bannière et synchronise l'état actif au scroll. Idempotent.
   NB 04/07/2026 : sélecteur générique [class*="bento-box--items-"] (items-4 → items-5 avec Vape CBD). */
(function () {
  function initSlider(track) {
    if (track.dataset.kdDotsInit) return;
    var items = Array.prototype.slice.call(track.children).filter(function (el) {
      return el.classList && el.classList.contains('bento-box__item');
    });
    if (items.length < 2) return;
    track.dataset.kdDotsInit = '1';

    var dots = document.createElement('div');
    dots.className = 'kd-slider-dots';
    dots.setAttribute('role', 'tablist');

    items.forEach(function (item, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kd-slider-dot';
      b.setAttribute('aria-label', 'Aller à la diapositive ' + (idx + 1));
      b.addEventListener('click', function () {
        item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dots.appendChild(b);
    });
    track.parentNode.insertBefore(dots, track.nextSibling);

    var dotEls = Array.prototype.slice.call(dots.children);
    var raf;
    function update() {
      var trLeft = track.getBoundingClientRect().left;
      var best = 0, bestDist = Infinity;
      items.forEach(function (item, i) {
        var d = Math.abs(item.getBoundingClientRect().left - trLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      dotEls.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === best);
      });
    }
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function run() {
    var tracks = document.querySelectorAll('[class*="bento-box--items-"]');
    Array.prototype.forEach.call(tracks, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // GemPages peut rendre tardivement → on repasse au load
  window.addEventListener('load', run);
})();
